import { Immutable } from "immer";
import React from "react";

import type { MediaSection as Value } from "@reactivated";

import { originalUrl } from "../../utils/wagtail";

type IProps = Immutable<{
    value: Value;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/media_sections/media_section.html`` (#33285).
 *
 * - The legacy class attr emitted `` banner--reverse `` (extra whitespace)
 *   only when ``orientation == 'right'``; whitespace differences in class
 *   attrs are fine.
 * - ``description`` is the serialized RichTextBlock string, which INCLUDES
 *   the ``<div class="rich-text">`` wrapper -- exactly what the legacy
 *   ``{{ self.description|richtext }}`` emitted inside
 *   ``<div class="banner__copy alt-copy">``; injecting it is exact parity.
 */
export const MediaSection = (props: IProps): React.JSX.Element => {
    const reverse =
        props.value.orientation === "right" ? " banner--reverse" : "";
    return (
        <section className={`banner ptb${reverse}`}>
            <div className="banner__figure">
                {/* Decorative images have empty alt attr */}
                <img
                    className="img-responsive"
                    src={originalUrl(props.value.image)}
                    alt=""
                    loading="lazy"
                    decoding="async"
                />
            </div>

            <div className="banner__content banner__content--rtq">
                <h5 className="banner__title">{props.value.title}</h5>
                <div
                    className="banner__copy alt-copy"
                    dangerouslySetInnerHTML={{
                        __html: props.value.description ?? "",
                    }}
                />
            </div>
        </section>
    );
};
